

































import {Component, Prop, Provide, Vue} from 'vue-property-decorator'
import {Helper} from 'simpli-web-sdk'
import moment from 'moment'
import {PanelUser} from '@/model/resource/PanelUser'

@Component
export default class ModalUpdateActiveInternacional extends Vue {
  model = new PanelUser()

  openEvent(id?: number) {
    this.$emit('open')

    if (id) {
      this.model.getPanelUser(id)
    } else {
      this.close()
    }
  }

  closeEvent() {
    this.model.reset()
    this.$emit('close')
  }

  validate(date: string | null) {
    const d = moment(date ?? '')
    return moment(d).isValid()
  }

  async confirmEvent() {
    await this.model.updateActive(false)
    await Helper.success('system.success.persist')
    window.location.reload()
    this.close()
  }

  async cancelEvent() {
    this.$emit('cancel')
    this.close()
  }

  close() {
    this.$modal.close('updateActiveInternational')
    this.$tip.hideAll()
  }
}
